import { DEFAULT_CHAT_SETTINGS, ON_NEW_MESSAGE } from '@wix/inbox-common';
import { fonts } from '../reducers/fonts';
import {
  updateEditorSettingsDesign,
  updateEditorSettingsLayout,
  updateEditorSettingsTexts,
  updateEditorSettingsBehaviour,
  updateSiteColors,
  updateStyleParamsColors,
  updateStyleParamsFonts,
} from '../actions';
import colors from '../reducers/colors';
import {
  editorSettingsDesign,
  editorSettingsLayout,
  editorSettingsTexts,
  editorSettingsBehaviour,
} from '../reducers/editorSettings';

export interface SiteData {
  styleParams?: {
    colors?: any;
    booleans?: any;
    fonts?: any;
  };
  siteColors?: any;
  publicData?: {
    texts?: {
      onlineTitle?: string;
      onlineMessage?: string;
      offlineTitle?: string;
      offlineMessage?: string;
      offlineChatMessage?: string;
    };
    design?: {
      selectedBackgroundPattern?: string;
      selectedImageOption?: string;
      selectedRadiusOption?: string;
    };
    layout?: {
      position?: string;
      collapsedAsRounded?: boolean;
    };
    behaviour?: {
      onNewMessage?: string;
      responseTimeEnabled?: boolean;
      responseTimeSelected?: string;
    };
  };
}

export const extractSiteData = (siteData: SiteData, experiments?: any) => {
  const { siteColors, publicData, styleParams } = siteData || ({} as SiteData);

  const defaultBehaviour = {
    ...DEFAULT_CHAT_SETTINGS.behaviour,
  };
  if (
    experiments &&
    experiments['specs.chat.MessageNotificationShowBubbleByDefault'] === 'true'
  ) {
    defaultBehaviour.onNewMessage = ON_NEW_MESSAGE.SHOW_NOTIFICATION;
  }

  return {
    fonts: fonts(
      undefined,
      updateStyleParamsFonts(styleParams && styleParams.fonts),
    ),
    colors: colors(
      colors(undefined, updateSiteColors(siteColors)),
      updateStyleParamsColors(styleParams && styleParams.colors),
    ),
    editorSettingsDesign: editorSettingsDesign(
      editorSettingsDesign(
        undefined,
        updateEditorSettingsDesign(DEFAULT_CHAT_SETTINGS.design),
      ),
      updateEditorSettingsDesign(publicData && publicData.design),
    ),
    editorSettingsLayout: editorSettingsLayout(
      editorSettingsLayout(
        undefined,
        updateEditorSettingsLayout({
          ...DEFAULT_CHAT_SETTINGS.layout,
          collapsedAsRounded:
            (styleParams &&
              styleParams.booleans &&
              styleParams.booleans.collapsedAsRounded) ||
            DEFAULT_CHAT_SETTINGS.layout.collapsedAsRounded,
        }),
      ),
      updateEditorSettingsLayout(publicData && publicData.layout),
    ),
    editorSettingsTexts: editorSettingsTexts(
      editorSettingsTexts(
        undefined,
        updateEditorSettingsTexts(DEFAULT_CHAT_SETTINGS.texts),
      ),
      updateEditorSettingsTexts(publicData && publicData.texts),
    ),
    editorSettingsBehaviour: editorSettingsBehaviour(
      editorSettingsBehaviour(
        undefined,
        updateEditorSettingsBehaviour(defaultBehaviour),
      ),
      updateEditorSettingsBehaviour(publicData && publicData.behaviour),
    ),
  };
};
